import { z } from "zod";

export enum ESiteBonusTransferStatus {
  INITIALIZED = "INITIALIZED",
  SUBMISSION_ERROR = "SUBMISSION_ERROR",
  CONSENT_ERROR = "CONSENT_ERROR",
  SUBMITTED = "SUBMITTED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  BOOKED = "BOOKED",
  NONEXISTENT = "NONEXISTENT",
}

export const siteBonusTransferStatusDtoSchema = z.nativeEnum(ESiteBonusTransferStatus);

export const siteBonusTransferDtoSchema = z.object({
  bankingInformationReceptionDate: z.coerce.date().nullable(),
  externalTransferId: z.string().nullable(),
  externalTransferStatus: siteBonusTransferStatusDtoSchema,
  offerExpirationDate: z.coerce.date().nullable(),
  label: z.string().nullable(),
});

export const siteStatusDtoSchema = z.object({
  lastBonusTransfer: siteBonusTransferDtoSchema.nullable(),
});

export type TSiteBonusTransferStatusDto = z.infer<typeof siteBonusTransferStatusDtoSchema>;
export type TSiteBonusTransferDto = z.infer<typeof siteBonusTransferDtoSchema>;
export type TBonusTransferSiteStatusDto = z.infer<typeof siteStatusDtoSchema>;
